import type { ToolCallTranslationContext } from './translateAiTool';

/**
 * Returns true when `value` is a non-array object.
 */
function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * Adds spawn-tool interpolation keys from tool output (`jobState`, optional `jobErrorSuffix`).
 * Used by spawnAgent output i18n templates.
 */
export function enrichSpawnToolCallContext(
  toolCall: ToolCallTranslationContext,
): Record<string, unknown> {
  const output = toolCall.output;
  if (!isRecord(output)) {
    return {};
  }

  const jobState = output.jobState;
  if (typeof jobState !== 'string' || jobState.length === 0) {
    return {};
  }

  const context: Record<string, unknown> = { jobState, jobErrorSuffix: '' };

  const jobError = output.error;
  if (typeof jobError === 'string' && jobError.length > 0) {
    context.jobError = jobError;
    context.jobErrorSuffix = `: ${jobError}`;
  }

  return context;
}
